freespinSpinButton = {};

freespinSpinButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);

	button.canEnable = function() {
		return (!button._flags.modal.active && freespins.canEnableSpin());
	};

	button.canShow = function() {
		return (!button._flags.modal.active && freespins.canShowSpin());
	};

	button.onPressedCallback = function() {
		gdk.getNextGameOutcome(function() {});
		freespins.startGame();
	};

	return button;
};

freespinSpinButton.initialise = function(json, object) {};
freespinSpinButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("freespinSpinButton", freespinSpinButton.create, freespinSpinButton.initialise, freespinSpinButton.getFilesRequired);